export enum TeamSpaceType {
  COMMON = 'Common',
  INDIVIDUAL = 'Individual',
  PRIVATE = 'Private',
}
